import * as pas from 'js/hooks/auth/pas';

import { ERRORS } from './constants';
import { validateChallengeAnswer } from './actions';

export const oapiValidateChallengeAnswer = ({ responseToken, onValidate, onError, operation }) => {
    const handleSuccess = ({ data }) => onValidate(data);
    const handleError = ({ data }) => onError(data);

    validateChallengeAnswer({
        operation,
        responseToken
    }).then(handleSuccess, handleError);
};

export const pasValidateChallengeAnswer = ({ responseToken, onValidate, onError, operation }) => {
    const callback = ({ token, expirationTime }) => {
        if (!token) {
            onError(ERRORS.PAS_VALIDATION_ERROR);
        } else {
            onValidate({ token, expirationTime });
        }
    };

    pas.validateChallengeAnswer({ responseToken, operation, callback });
};

export default (options) => {
    const { operation } = options;

    switch (operation) {
        case 'signup':
        case 'checkUsernameAvailability':
        case 'forgotUsername':
        case 'forgotEmail':
        case 'validatePlayerData':
            oapiValidateChallengeAnswer(options);
            break;
        case 'login':
        case 'forgotPassword':
            pasValidateChallengeAnswer(options);
            break;
        default:
            throw Error('Unsupported operation');
    }
};
